import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CurrentUserFragment } from '@new/common/services/current-user.generated';
import { WindowService } from '@new/common/services/window.service';
import { ContextState } from '@new/common/state/context';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PoolBreadcrumbComponent } from './pools-breadcrumb/pool-breadcrumb.component';
import { UserMenuComponent } from './user-menu/user-menu.component';

@Component({
  selector: 'man-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, PoolBreadcrumbComponent, UserMenuComponent]
})
export class AppHeaderComponent {
  public currentUser$: Observable<CurrentUserFragment | undefined>;

  constructor(
    private readonly windowService: WindowService,
    private store: Store
  ) {
    this.currentUser$ = this.store.select(ContextState.currentUser);
  }

  public onLogout(): Promise<void> {
    return fetch('/logout', { method: 'DELETE' }).then(() => {
      this.windowService.href = '/login';
    });
  }
}
